// extracted by mini-css-extract-plugin
module.exports = {"list":"experiments_list__HkuRG","divider":"experiments_divider__KhMio","section":"experiments_section__3Ow6Y"};